import { memo, useEffect, useState } from "react";
import { SecurityLogoProps } from "./securityLogo.typings";
import { getStrategyIconFromText } from "../../util/strategyBuilder";
import { getSecurityAsync, getSecurityKey } from "../../util/security";
import { convertExpressionToDisplayExpression } from "../../util/expression";
import { Avatar, useTheme } from "@mui/material";
import { LOGOS_BASE_URL } from "../../assets/constants";
import { getColorForSymbol } from "../../util/general";
import { Security } from "../../proto/generated/security";

const SecurityLogo: React.FC<SecurityLogoProps> = ({ securityList, expression, expressionName, expressionMode, size = 20, fontSize = 12 }) => {

    const { palette: { background } } = useTheme()
    const [primarySecurity, setPrimarySecurity] = useState<Security | undefined>()
    const [expressionSecurities, setExpressionSecurities] = useState<Security[]>([])

    useEffect(() => {
        if (!securityList.length) {
            setPrimarySecurity(undefined)
            setExpressionSecurities([])
            return
        }
        if (!expressionMode) {
            setExpressionSecurities([])
            const key = getSecurityKey(securityList[0]?.exchange, securityList[0]?.code)
            getSecurityAsync(key).then(setPrimarySecurity)
        } else {
            setPrimarySecurity(undefined)
            Promise.all(securityList.map(v => getSecurityAsync(getSecurityKey(v.exchange, v.code))))
                .then(secs => setExpressionSecurities(secs.filter((s): s is Security => !!s)))
        }
    }, [securityList, expressionMode])

    if (!securityList.length) return <></>
    let altText = ''
    if (!expressionMode) {
        const security = primarySecurity
        if (!security) return <></>
        altText = security.displayName || security.symbol || ''
        const initials = (security.symbol || '').split(' ').map((word) => word[0]?.toUpperCase()).slice(0, 2).join('')
        if (security?.logoUrl) {
            return <Avatar alt={altText} src={`${LOGOS_BASE_URL}${security.logoUrl}.svg`} sx={{ width: size, height: size }}>{initials}</Avatar>
        }
        return <Avatar alt={altText} sx={{ width: size, height: size, fontSize, color: 'white', bgcolor: getColorForSymbol(security?.symbol ?? '', background.default) }}>{(security?.symbol || '').split(' ').map((word) => word[0]?.toUpperCase()).slice(0, 2).join('')}</Avatar>
    }
    altText = expressionName || convertExpressionToDisplayExpression(expression, expressionSecurities)
    let initials = expressionName ? getStrategyIconFromText(expressionName) : ''
    let bgColor = background.default
    if (!initials) {
        initials = securityList.map((s) => s.code).join(' ').split(' ').map((word) => word[0]?.toUpperCase()).slice(0, 2).join('')
        bgColor = getColorForSymbol(securityList.map((s) => s.code).join(' '), background.default)
    }
    return <Avatar alt={altText} sx={{ width: size, height: size, color: 'white', fontSize, background: bgColor }}>{initials}</Avatar>
}

export default memo(SecurityLogo);